import '../../assets/index51.css';var we = Object.defineProperty, Ce = Object.defineProperties;
var Ne = Object.getOwnPropertyDescriptors;
var k = Object.getOwnPropertySymbols;
var Y = Object.prototype.hasOwnProperty, G = Object.prototype.propertyIsEnumerable;
var U = (t, e, n) => e in t ? we(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, u = (t, e) => {
  for (var n in e || (e = {}))
    Y.call(e, n) && U(t, n, e[n]);
  if (k)
    for (var n of k(e))
      G.call(e, n) && U(t, n, e[n]);
  return t;
}, g = (t, e) => Ce(t, Ne(e));
var z = (t, e) => {
  var n = {};
  for (var o in t)
    Y.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
  if (t != null && k)
    for (var o of k(t))
      e.indexOf(o) < 0 && G.call(t, o) && (n[o] = t[o]);
  return n;
};
import { jsx as E, jsxs as Re } from "react/jsx-runtime";
import { useEffect as N, useRef as v, useCallback as J, useState as C, createElement as P, forwardRef as Se } from "react";
import { a as $e, c as Ie, e as Te } from "../../get-size-Bc1Pz5yf.js";
import { c as V } from "../../create-vars-resolver-Bzbn9G-G.js";
import { f as ee, u as te, B as x, b as ke, h as ze } from "../../factory-ueRxoNOV.js";
import { g as Oe } from "../../get-contrast-color-SC35uhiM.js";
import { u as ne } from "../../use-styles-DToiHEa6.js";
import { g as xe } from "../../get-env-CiXMSQeN.js";
import { t as O } from "../../to-int-CHbRl5M-.js";
import { u as oe } from "../../use-merged-ref-n551Tfbr.js";
import { r as Q, u as Ee } from "../../use-id-D2tGiO9x.js";
import { u as Fe } from "../../use-uncontrolled-BT_j5D2R.js";
function We(t, e) {
  if (t === e || Number.isNaN(t) && Number.isNaN(e))
    return !0;
  if (!(t instanceof Object) || !(e instanceof Object))
    return !1;
  const n = Object.keys(t), { length: o } = n;
  if (o !== Object.keys(e).length)
    return !1;
  for (let i = 0; i < o; i += 1) {
    const s = n[i];
    if (!(s in e) || t[s] !== e[s] && !(Number.isNaN(t[s]) && Number.isNaN(e[s])))
      return !1;
  }
  return !0;
}
function Le(t, e) {
  if (!t || !e)
    return !1;
  if (t === e)
    return !0;
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; n += 1)
    if (!We(t[n], e[n]))
      return !1;
  return !0;
}
function Pe(t) {
  const e = v([]), n = v(0);
  return Le(e.current, t) || (e.current = t, n.current += 1), [n.current];
}
function je(t, e) {
  N(t, Pe(e));
}
function Be(t, e, n = { autoInvoke: !1 }) {
  const o = v(null), i = J(
    (...d) => {
      o.current || (o.current = window.setTimeout(() => {
        t(d), o.current = null;
      }, e));
    },
    [e]
  ), s = J(() => {
    o.current && (window.clearTimeout(o.current), o.current = null);
  }, []);
  return N(() => (n.autoInvoke && i(), s), [s, i]), { start: i, clear: s };
}
function Me(t, e, n) {
  const o = v(null), i = v(null);
  return N(() => {
    const s = typeof n == "function" ? n() : n;
    return (s || i.current) && (o.current = new MutationObserver(t), o.current.observe(s || i.current, e)), () => {
      var d;
      (d = o.current) == null || d.disconnect();
    };
  }, [t, e]), i;
}
function Ae() {
  const [t, e] = C(!1);
  return N(() => e(!0), []), t;
}
function De(t, e) {
  if (!e || !t)
    return !1;
  let n = e.parentNode;
  for (; n != null; ) {
    if (n === t)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function Xe({
  target: t,
  parent: e,
  ref: n,
  displayAfterTransitionEnd: o
}) {
  const i = v(-1), [s, d] = C(!1), [R, S] = C(
    typeof o == "boolean" ? o : !1
  ), c = () => {
    if (!t || !e || !n.current)
      return;
    const a = t.getBoundingClientRect(), l = e.getBoundingClientRect(), m = window.getComputedStyle(t), h = window.getComputedStyle(e), $ = O(m.borderTopWidth) + O(h.borderTopWidth), _ = O(m.borderLeftWidth) + O(h.borderLeftWidth), b = {
      top: a.top - l.top - $,
      left: a.left - l.left - _,
      width: a.width,
      height: a.height
    };
    n.current.style.transform = `translateY(${b.top}px) translateX(${b.left}px)`, n.current.style.width = `${b.width}px`, n.current.style.height = `${b.height}px`;
  }, f = () => {
    window.clearTimeout(i.current), n.current && (n.current.style.transitionDuration = "0ms"), c(), i.current = window.setTimeout(() => {
      n.current && (n.current.style.transitionDuration = "");
    }, 30);
  }, y = v(null), p = v(null);
  return N(() => {
    if (c(), t)
      return y.current = new ResizeObserver(f), y.current.observe(t), e && (p.current = new ResizeObserver(f), p.current.observe(e)), () => {
        var a, l;
        (a = y.current) == null || a.disconnect(), (l = p.current) == null || l.disconnect();
      };
  }, [e, t]), N(() => {
    if (e) {
      const a = (l) => {
        De(l.target, e) && (f(), S(!1));
      };
      return e.addEventListener("transitionend", a), () => {
        e.removeEventListener("transitionend", a);
      };
    }
  }, [e]), Be(
    () => {
      xe() !== "test" && d(!0);
    },
    20,
    { autoInvoke: !0 }
  ), Me(
    (a) => {
      a.forEach((l) => {
        l.type === "attributes" && l.attributeName === "dir" && f();
      });
    },
    { attributes: !0, attributeFilter: ["dir"] },
    () => document.documentElement
  ), { initialized: s, hidden: R };
}
var re = { root: "m_96b553a6" };
const qe = {}, He = V(
  (t, { transitionDuration: e }) => ({
    root: {
      "--transition-duration": typeof e == "number" ? `${e}ms` : e
    }
  })
), j = ee((t, e) => {
  const n = te("FloatingIndicator", qe, t), I = n, {
    classNames: o,
    className: i,
    style: s,
    styles: d,
    unstyled: R,
    vars: S,
    target: c,
    parent: f,
    transitionDuration: y,
    mod: p,
    displayAfterTransitionEnd: a
  } = I, l = z(I, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "target",
    "parent",
    "transitionDuration",
    "mod",
    "displayAfterTransitionEnd"
  ]), m = ne({
    name: "FloatingIndicator",
    classes: re,
    props: n,
    className: i,
    style: s,
    classNames: o,
    styles: d,
    unstyled: R,
    vars: S,
    varsResolver: He
  }), h = v(null), { initialized: $, hidden: _ } = Xe({
    target: c,
    parent: f,
    ref: h,
    displayAfterTransitionEnd: a
  }), b = oe(e, h);
  return !c || !f ? null : /* @__PURE__ */ E(x, u(u({ ref: b, mod: [{ initialized: $, hidden: _ }, p] }, m("root")), l));
});
j.displayName = "@mantine/core/FloatingIndicator";
j.classes = re;
var se = { root: "m_cf365364", indicator: "m_9e182ccd", label: "m_1738fcb2", input: "m_1714d588", control: "m_69686b9b", innerLabel: "m_78882f40" };
const Ke = {
  withItemsBorders: !0
}, Ue = V(
  (t, { radius: e, color: n, transitionDuration: o, size: i, transitionTimingFunction: s }) => ({
    root: {
      "--sc-radius": e === void 0 ? void 0 : Te(e),
      "--sc-color": n ? ze(n, t) : void 0,
      "--sc-shadow": n ? void 0 : "var(--mantine-shadow-xs)",
      "--sc-transition-duration": o === void 0 ? void 0 : `${o}ms`,
      "--sc-transition-timing-function": s,
      "--sc-padding": Ie(i, "sc-padding"),
      "--sc-font-size": $e(i)
    }
  })
), B = ee((t, e) => {
  var X, q, H, K;
  const n = te("SegmentedControl", Ke, t), D = n, {
    classNames: o,
    className: i,
    style: s,
    styles: d,
    unstyled: R,
    vars: S,
    data: c,
    value: f,
    defaultValue: y,
    onChange: p,
    size: a,
    name: l,
    disabled: m,
    readOnly: h,
    fullWidth: $,
    orientation: _,
    radius: b,
    color: I,
    transitionDuration: Ve,
    transitionTimingFunction: et,
    variant: ie,
    autoContrast: ae,
    withItemsBorders: le,
    mod: ue
  } = D, ce = z(D, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "data",
    "value",
    "defaultValue",
    "onChange",
    "size",
    "name",
    "disabled",
    "readOnly",
    "fullWidth",
    "orientation",
    "radius",
    "color",
    "transitionDuration",
    "transitionTimingFunction",
    "variant",
    "autoContrast",
    "withItemsBorders",
    "mod"
  ]), w = ne({
    name: "SegmentedControl",
    props: n,
    classes: se,
    className: i,
    style: s,
    classNames: o,
    styles: d,
    unstyled: R,
    vars: S,
    varsResolver: Ue
  }), M = ke(), A = c.map(
    (r) => typeof r == "string" ? { label: r, value: r } : r
  ), de = Ae(), [fe, me] = C(Q()), [ge, ve] = C(null), [F, he] = C({}), pe = (r, L) => {
    F[L] = r, he(F);
  }, [T, be] = Fe({
    value: f,
    defaultValue: y,
    finalValue: Array.isArray(c) && (K = (H = (X = A.find((r) => !r.disabled)) == null ? void 0 : X.value) != null ? H : (q = c[0]) == null ? void 0 : q.value) != null ? K : null,
    onChange: p
  }), W = Ee(l), ye = A.map((r) => /* @__PURE__ */ P(
    x,
    g(u({}, w("control")), {
      mod: { active: T === r.value, orientation: _ },
      key: r.value
    }),
    /* @__PURE__ */ P(
      "input",
      g(u({}, w("input")), {
        disabled: m || r.disabled,
        type: "radio",
        name: W,
        value: r.value,
        id: `${W}-${r.value}`,
        checked: T === r.value,
        onChange: () => !h && be(r.value),
        "data-focus-ring": M.focusRing,
        key: `${r.value}-input`
      })
    ),
    /* @__PURE__ */ P(
      x,
      g(u({
        component: "label"
      }, w("label")), {
        mod: {
          active: T === r.value && !(m || r.disabled),
          disabled: m || r.disabled,
          "read-only": h
        },
        htmlFor: `${W}-${r.value}`,
        ref: (L) => pe(L, r.value),
        __vars: {
          "--sc-label-color": I !== void 0 ? Oe({ color: I, theme: M, autoContrast: ae }) : void 0
        },
        key: `${r.value}-label`
      }),
      /* @__PURE__ */ E("span", g(u({}, w("innerLabel")), { children: r.label }))
    )
  )), _e = oe(e, (r) => ve(r));
  return je(() => {
    me(Q());
  }, [c.length]), c.length === 0 ? null : /* @__PURE__ */ Re(
    x,
    g(u(g(u({}, w("root")), {
      variant: ie,
      size: a,
      ref: _e,
      mod: [
        {
          "full-width": $,
          orientation: _,
          initialized: de,
          "with-items-borders": le
        },
        ue
      ]
    }), ce), {
      role: "radiogroup",
      "data-disabled": m,
      children: [
        typeof T == "string" && /* @__PURE__ */ E(
          j,
          u({
            target: F[T],
            parent: ge,
            component: "span",
            transitionDuration: "var(--sc-transition-duration)"
          }, w("indicator")),
          fe
        ),
        ye
      ]
    })
  );
});
B.classes = se;
B.displayName = "@mantine/core/SegmentedControl";
const Ye = "SegmentedControl-module__root___X-Vyz", Ge = "SegmentedControl-module__control___fxOxs", Je = "SegmentedControl-module__label___3A8-4", Qe = "SegmentedControl-module__indicator___sfk4y", Z = {
  root: Ye,
  control: Ge,
  label: Je,
  indicator: Qe
}, Ze = Se(
  (i, o) => {
    var s = i, { className: t, size: e = "md" } = s, n = z(s, ["className", "size"]);
    return /* @__PURE__ */ E(
      B,
      g(u({
        ref: o,
        classNames: g(u({}, Z), {
          indicator: Z.indicator
        }),
        transitionDuration: 200,
        transitionTimingFunction: "ease"
      }, n), {
        mod: { size: e }
      })
    );
  }
);
Ze.displayName = "SegmentedControl";
export {
  Ze as SegmentedControl
};
